const isVersionAtLeast = (currentVersion, minVersion) => {
  const currentVersionParts = currentVersion?.split('.');
  const minVersionParts = minVersion?.split('.');

  for (let i = 0; i < currentVersionParts?.length; i++) {
    const current = +currentVersionParts[i];
    const min = +minVersionParts[i];
    if (current > min) return true;
    if (current < min) return false;
  }

  return currentVersionParts?.length >= minVersionParts?.length;
};

export const isIOSNewVersion = () => {
  const minAppVersion = '22';
  const minOsVersion = '26.5';
  const userAgent = window?.navigator?.userAgent;

  if (!userAgent || !userAgent.includes('MF_APP_VERSION') || !userAgent.includes('osVersion') || !userAgent.includes('iPhone')) {
    return false;
  }

  const userAgentItems = userAgent.split(';');
  const currentAppVersion = userAgentItems?.find(t => t?.includes('MF_APP_VERSION'))?.substring(15);
  const currentOsVersion = userAgentItems?.find(t => t?.includes('osVersion:'))?.substring(10);

  if (!currentAppVersion || !currentOsVersion) {
    return false;
  }

  return isVersionAtLeast(currentAppVersion, minAppVersion) && isVersionAtLeast(currentOsVersion, minOsVersion);
};

const util = {
  isIOSNewVersion,
};

export default util;
